
import OverlayGridItemBadges from './OverlayGridItemBadges'
import OverlayGridItemInfo from './OverlayGridItemInfo'
import OverlayGridItemMedia from './OverlayGridItemMedia'

export default {
  name: 'OverlayGridItem',

  components: {
    OverlayGridItemBadges,
    OverlayGridItemInfo,
    OverlayGridItemMedia
  },

  props: {
    portrait: Boolean,
    presentingMode: Boolean,
    hoverMode: Boolean,
    enableOpacity: Boolean,
    enableLabel: Boolean,
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
    itemPosition: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      muted: true,
      mouseover: false,
      transitioning: false,
      videoLoaded: false
    }
  },

  computed: {
    classes () {
      return {
        '2xl:scale-120 z-20': this.hoverMode && this.isSecondTheme,
        'lg:hover:scale-125': !this.hoverMode,
        'z-20': this.mouseover && !this.hoverMode,
        'z-10': !this.mouseover && this.transitioning && !this.hoverMode
      }
    },
    isMobile () {
      if (process.browser) {
        return window.innerWidth < 1024
      }

      return false
    },
    isSecondTheme () {
      return this.itemPosition === this.$store.state.secondThemePosition
    }
  },
  methods: {
    selectItem () {
      if (this.hoverMode) {
        if (this.isSecondTheme) {
          this.$emit('select')
        }

        return
      }

      this.$emit('select')
    },

    mouseEnter () {
      if (this.isMobile) {
        return
      }

      this.mouseover = true
      this.muted = true
    },

    mouseLeave () {
      this.mouseover = false
      this.transitioning = true
    }
  }
}
